import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'

function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false)

  // Custom error boundary logic using try-catch in render
  try {
    if (hasError) {
      return <Navigate to="/error" replace />
    }
    return children
  } catch (error) {
    setHasError(true)
    return null
  }
}

export default ErrorBoundary
